import axios from "helpers/_axios";
import { has } from "lodash";
export const LOADING_CLIENT = "LOADING_CLIENT";
export const ERROR_CLIENT = "ERROR_CLIENT";
export const SET_CLIENT = "SET_CLIENT";
export const GET_ALL_CLIENTS = "GET_ALL_CLIENTS";
export const GET_SELECTED_CLIENT = "GET_SELECTED_CLIENT";
export const GET_CLIENT = "GET_CLIENT";
export const GET_ACCURACY = "GET_ACCURACY";
export const ADD_CLIENT = "ADD_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";

// Subordinates
export const LOADING_SUBORDINATES = "LOADING_SUBORDINATES";
export const SUBORDINATES = "SUBORDINATES";
export const ERROR_SUBORDINATES = "ERROR_SUBORDINATES";

export const getAllClients =
  ({ name = "", page = 1 }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_CLIENT,
        payload: true
      });
      const result = await axios().get(`/clients?page=${page}&name=${name}`);
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      return dispatch({
        type: GET_ALL_CLIENTS,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      dispatch({
        type: GET_ALL_CLIENTS,
        payload: null
      });
      dispatch({
        type: ERROR_CLIENT,
        payload: error.response
      });
    }
  };

export const getAccuracy = clientId => async dispatch => {
  try {
    dispatch({
      type: LOADING_CLIENT,
      payload: true
    });
    const result = await axios().get(`/clients/${clientId}/accuracy`);
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: GET_ACCURACY,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: GET_ACCURACY,
      payload: null
    });
    dispatch({
      type: ERROR_CLIENT,
      payload: error
    });
  }
};

/**
 *  Fetches all the subordinates of a user by client id
 * @param {string} clientId
 * @param {string} keyword Search string (fullname/email) of the subordinate user
 * @returns
 */
export const getSubordinates =
  (clientId, keyword = "") =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_SUBORDINATES,
        payload: true
      });
      const result = await axios().get(`/clients/${clientId}/subordinates`, {
        params: {
          subordinate: keyword
        }
      });
      dispatch({
        type: LOADING_SUBORDINATES,
        payload: false
      });
      dispatch({
        type: SUBORDINATES,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_SUBORDINATES,
        payload: false
      });
      dispatch({
        type: SUBORDINATES,
        payload: null
      });
      dispatch({
        type: ERROR_SUBORDINATES,
        payload: error
      });
    }
  };

export const getClient = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_CLIENT,
      payload: true
    });
    const result = await axios().get(`/clients/${id}`);
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: GET_CLIENT,
      payload: result.data
    });
    result.data.data.department_item_value = localStorage.getItem(
      "department_item_value"
    );
    dispatch({
      type: SET_CLIENT,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: GET_CLIENT,
      payload: null
    });
    dispatch({
      type: ERROR_CLIENT,
      payload: error
    });
  }
};

export const setClient = client => dispatch => {
  if (!client) return;
  // Store selected client in localstorage
  localStorage.setItem("selectedClient", JSON.stringify(client));
  return dispatch({
    type: SET_CLIENT,
    payload: client
  });
};

export const getSelectedClient = () => dispatch => {
  dispatch({
    type: LOADING_CLIENT,
    payload: true
  });
  const client = localStorage.getItem("selectedClient");
  dispatch({
    type: LOADING_CLIENT,
    payload: false
  });
  return dispatch({
    type: GET_SELECTED_CLIENT,
    payload: client ? JSON.parse(client) : null
  });
};

export const addClient = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_CLIENT,
      payload: true
    });
    const result = await axios().post(`/clients`, data);
    dispatch({
      type: ERROR_CLIENT,
      payload: null
    });
    dispatch({
      type: ADD_CLIENT,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: ERROR_CLIENT,
      payload: error
    });
    dispatch({
      type: ADD_CLIENT,
      payload: null
    });
  }
};

export const updateClient =
  ({ id, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_CLIENT,
        payload: true
      });
      const result = await axios().put(`/clients/${id}`, data);
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      dispatch({
        type: ERROR_CLIENT,
        payload: null
      });
      dispatch({
        type: UPDATE_CLIENT,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      dispatch({
        type: ERROR_CLIENT,
        payload: error
      });
      dispatch({
        type: UPDATE_CLIENT,
        payload: null
      });
    }
  };

export const updateFileBatchSize =
  ({ clientId, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_CLIENT,
        payload: true
      });
      const result = await axios().put(
        `/clients/${clientId}/file-batch-size`,
        data
      );
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      dispatch({
        type: ERROR_CLIENT,
        payload: null
      });
      dispatch({
        type: UPDATE_CLIENT,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_CLIENT,
        payload: false
      });
      dispatch({
        type: ERROR_CLIENT,
        payload: error
      });
      dispatch({
        type: UPDATE_CLIENT,
        payload: null
      });
    }
  };

export const deleteClient = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_CLIENT,
      payload: true
    });
    const result = await axios().delete(`/clients/${id}`);
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: ERROR_CLIENT,
      payload: null
    });
    dispatch({
      type: DELETE_CLIENT,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: DELETE_CLIENT,
      payload: has(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_CLIENT,
      payload: false
    });
    dispatch({
      type: ERROR_CLIENT,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
